const initialState = {
  data: null,
  loading: false,
  dismissed: false,
};

export const buyerOnboarding = (state = initialState, action) => {
  switch (action.type) {
    case "GET_BUYER_ONBOARDING_STATUS_REQUEST":
      return { ...state, loading: true };
    case "GET_BUYER_ONBOARDING_STATUS":
      return { ...state, data: action.payload, loading: false };
    case "GET_BUYER_ONBOARDING_STATUS_FAILURE":
      return { ...state, loading: false };
    case "DISMISS_BUYER_ONBOARDING":
      return { ...state, dismissed: true };
    default:
      return state;
  }
};
